import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
/*
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
*/
import TabPanel from '../TabPanel/TabPanel';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import './dialog.css';

const ActionDialog = ({ title, mode, open, onClose, onSave, defaultTab = 'properties', propertiesTabContent, jsonDataName, JSONTabContent, handleJsonChange, disablePropertiesTab = false, saveButtonText = 'Save', cancelButtonText = 'Cancel', json_height = 300 }) => {

  // only 2 tabs so if default is not properties tab, then set to JSON tab
  const [value, setValue] = useState(defaultTab !== 'properties' ? 1 : 0);

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    onClose();
  };

  const handleSave = () => {
    onSave();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleJsonUpdate = (formData) => {
    //console.log("Inside Dialog JSON has changed", formData);

    handleJsonChange(formData);
  }

  const getJsonMode = () => {
    return mode === 'view' ? 'view' : 'tree';
  }

  const handleCopy = () => {
    let copyText = JSON.stringify(JSONTabContent, null, 2)
    navigator.clipboard.writeText(copyText);
  }

  return (
    <Dialog onClose={handleClose} open={open} maxWidth={'md'} fullWidth={true}
      PaperProps={{
        sx: {
          height: 540,
          maxHeight: 540
        }
      }}
    >
      <DialogTitle>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent dividers={true}>

        <Tabs value={value} onChange={handleChange} aria-label="dialog tabs"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#82C027",
              textColor: ""
            }
          }}
        >
          <Tab label="Properties" disabled={disablePropertiesTab} />
          <Tab label="JSON" />
        </Tabs>
        <TabPanel value={value} index={0}>
          {propertiesTabContent}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <IconButton
            sx={{
              position: "absolute",
              right: '54px',
              top: '100px',
            }}
            onClick={handleCopy}
            title="Copy JSON"
          >
            <ContentCopyIcon sx={{
              fontSize: 'small'
            }} />
          </IconButton>
          <Editor
            name={jsonDataName}
            mode={getJsonMode()}
            navigationBar={false}
            statusBar={false}
            search={false}
            history={false}
            value={JSONTabContent}
            onChange={handleJsonUpdate}
            htmlElementProps={{ style: { height: json_height, "overflow-y": "hidden" } }} />
        </TabPanel>
      </DialogContent>
      {mode !== 'view' && (
        <DialogActions>
          <Button variant="text" size="small" sx={{ textTransform: 'none' }} onClick={handleClose}>{cancelButtonText}</Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              color: '#333330',
              backgroundColor: '#82C027',
              boxShadow: '0px 1px 2px #6F7687',
              borderRadius: '5px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#82C027',
                boxShadow: 'none'
              }
            }}
            onClick={handleSave}>{saveButtonText}</Button>
        </DialogActions>
      )}
    </Dialog>

  );
}


export default ActionDialog;